export default {
  'developer_eccang_open': {
    cn: '易仓科技开放平台 (ECCANG)',
    en: 'Eccang Open Platform (ECCANG)', // ECCANG
    kr: '개방플랫폼 (ECCANG)'
  },
  'developer_eccang_open_1': {
    cn: '易仓科技开放平台',
    en: 'Eccang Open Platform', // ECCANG
    kr: '개방플랫폼'
  },
  'developer_创建应用': {
    cn: '创建应用',
    en: 'Create App', // ECCANG
    kr: '앱 만들기'
  },
  'developer_编辑应用': {
    cn: '编辑应用',
    en: 'Editor App', // ECCANG
    kr: '응용 프로그램 편집'
  },
  'developer_ECCANG生态中心': {
    cn: 'ECCANG生态中心',
    en: 'ECCANG Ecological Center', // ECCANG
    kr: 'ECCANG 생태 센터'
  },
  'developer_eccang_open_desc': {
    cn: '如您还没有创建应用，您可以到易仓科技开放平台中创建您的应用，自有应用创建成功后自动获取授权',
    en: 'If you have no created an application yet, you can create your application in the open platform of Yicang, and your own application will be automatically authorized after it is created successfully.', // ECCANG
    kr: '아직 애플리케이션을 생성하지 않았다면 Yicang의 개방형 플랫폼에서 애플리케이션을 생성할 수 있으며 성공적으로 생성된 후 자신의 애플리케이션이 자동으로 승인됩니다.'
  },
  'developer_创建应用_desc': {
    cn: '如果您是第三方开发者或已购买ECCANG软件需要自研的开发者，请操作创建应用',
    en: 'If you are a third-party developer or a developer who has purchased ECCANG software and needs to develop it yourself, please create an application', // ECCANG
    kr: 'ECCANG 소프트웨어를 구입한 타사 개발자 또는 개발자가 직접 개발해야 하는 경우 응용 프로그램을 만드십시오.'
  },
  'developer_ECCANG生态中心_desc': {
    cn: 'ECCANG生态中心由开放平台、应用市场提供一站式能力支持，支撑跨境电商公司级业务流程的标准化管理和应用灵活扩展，帮助您针对自己的独特业务需求创建所需的解决方案',
    en: 'ECCANG Ecological Center provides one-stop capability support from the open platform and application market, supports the standardized management and flexible application expansion of cross-border e-commerce company-level business processes, and helps you create the required solutions for your unique business needs', // ECCANG
    kr: 'ECCANG Ecological Center는 오픈 플랫폼 및 애플리케이션 마켓을 통해 원스톱 솔루션으로 크로스보더 비즈니스 비즈니스 프로세스 표준화 관리 및 애플리케이션 확장 기능을 지원하여 자신만의 독특한 비즈니스 요구에 맞는 솔루션을 구축할 수 있도록 지원합니다'
  },
  'add_authorization': {
    cn: '添加授权',
    en: 'Add authorization', // ECCANG
    kr: '승인 추가'
  },
  'add_authorization_desc': {
    cn: '如您还没有创建应用，可以点击「添加授权」为「第三方应用」开通授权',
    en: 'If you have no created an application yet, you can click "Add Authorization" to activate authorization for "Third Party Application"', // ECCANG
    kr: '아직 애플리케이션을 생성하지 않은 경우 "인증 추가"를 클릭하여 "타사 애플리케이션"에 대한 인증을 활성화할 수 있습니다.'
  },
  'developer_title_desc': {
    cn: '自有应用默认获取授权, 取消授权可在开放平台作废该应用',
    en: 'Own applications get authorization by default, and cancel authorization can invalidate the application on the open platform',
    kr: '자체 앱은 기본적으로 승인을 받으며 승인 취소는 개방형 플랫폼에서 애플리케이션을 무효화할 수 있습니다.'
  },
  'developer_作废': {
    cn: '作废',
    en: 'Invalid',
    kr: '무효의'
  },
  'developer_作废_desc': {
    cn: '是否作废?',
    en: 'Invalid or not?',
    kr: '무효화 여부?'
  },
  'developer_重置秘钥': {
    cn: '重置秘钥',
    en: 'Reset key',
    kr: '키 초기화'
  },
  'developer_重置秘钥_desc': {
    cn: '是否重置秘钥?',
    en: 'Whether to reset the secret key?',
    kr: '비밀 키를 초기화할지 여부입니다?'
  },
  'developer_为了规范互联网': {
    cn: '为了规范互联网信息服务活动，促进互联网信息服务健康有序发展，根据国家工信部规定，创建应用前请完成企业认证流程',
    en: 'In order to standardize Internet information service activities and promote the healthy and orderly development of Internet information services, according to the regulations of the Ministry of Industry and Information Technology, enterprises must complete the certification process before creating applications',
    kr: '인터넷정보서비스활동을 규범화하고 인터넷정보서비스의 건전하고 질서있는 발전을 촉진하기 위해 국가공업정보화부의 규정에 따라 구축, 응용전에 기업인증절차를 마쳐야 한다'
  },
  'developer_您提交的认证正在审核中': {
    cn: '您提交的认证正在审核中，预计三个工作日内完成审核。审核结果将通过系统消息通知您，您也可以在“开放平台”-“资质管理”中查看审核结果',
    en: 'The certification you submitted is under review, and the review is expected to be completed within three working days. The audit result will be notified to you through the system message. You can also view the audit result in "Open Platform" - "Qualification Management"',
    kr: '제출하신 인증서는 심사중이며, 3일 이내에 심사가 완료될 예정입니다.감사 결과는 시스템 메시지를 통해 알려지며, 개방형 플랫폼-자격 관리에서 결과를 볼 수 있습니다'
  },
  'developer_您提交的认证审核不通过': {
    cn: '您提交的认证审核不通过，您可以在“开放平台”-“资质管理”中查看审核不通过原因及重新发起资质审核',
    en: 'If the certification you submitted fails to pass the audit, you can check the reason of failure and re-launch the audit in "Open Platform" - "Qualification Management"',
    kr: '제출하신 인증이 불합격되었습니다. 귀하는"오픈 플랫폼"-"자격 관리"에서 불합격 사유를 확인하고 자격 재평가를 시작할 수 있습니다'
  },
  'developer_去认证': {
    cn: '去认证',
    en: 'Go to the certification',
    kr: '인증하기'
  },
  'developer_去看看': {
    cn: '去看看',
    en: 'Go and see',
    kr: '가서보다'
  },
  'developer_my_application': {
    cn: '我的应用',
    en: 'My App',
    kr: '내 응용프로그램 '
  },
  'developer_my_reserch_application': {
    cn: '自研应用',
    en: 'Self Developed Application',
    kr: '자체 연구 응용'
  },
  'developer_third_applications': {
    cn: '第三方应用',
    en: 'Third-party App',
    kr: '제3자 응용프로그램 '
  },
  'developer_服务商应用': {
    cn: '服务商应用',
    en: 'Service provider App',
    kr: '서비스제공자응용'
  },
  'developer_list_default_auth_text': {
    cn: '列表默认显示当前账号创建的应用，支持对【第三方应用】进行授权，【第三方应用】授权请点击{a}来操作',
    en: 'By default, the list shows the application created by the current account, which supports the authorization of【third-party application】. Please click {a} to operate 【third-party application】',
    kr: '리스트에 기본적으로 현재 계정에서 만든 응용프로그램이 표시되며 【제3자 응용프로그램】 승인을 지원합니다. 【제3자 응용프로그램】 승인은 {a}를 클릭하여 진행하십시오. '
  },
  'developer_you_can1': {
    cn: '你还没有创建应用，您可以',
    en: "You haven't created the app yet, you can",
    kr: '응용프로그램을 생성하지 않았습니다. 귀하는 '
  },
  'developer_you_can2': {
    cn: '1. 到{platform}中创建您的应用，自有应用创建成功后自动获取授权',
    en: '1. Create your application on the {platform}, and automatically obtain authorization after the successful creation of your own application',
    kr: '1. 到{platform}中创建您的应用，自有应用创建成功后自动获取授权'
  },
  'developer_you_can3': {
    cn: '2. 点击{add}可以为【第三方应用】开通授权',
    en: '2. Click {add} to open authorization for【third-party application】',
    kr: '2. 点击{add}可以为【第三方应用】开通授权'
  },
  'developer_proprietary_app_get': {
    cn: '自有应用默认获取授权',
    en: 'Proprietary applications get authorization by default',
    kr: '자체 응용프로그램은 기본적으로 승인을 받습니다. '
  },
  'developer_add_app_before_add_comp': {
    cn: '应用授权前请先添加企业信息',
    en: 'Add enterprise information before applying authorization',
    kr: '응용프로그램 승인 전에 먼저 회사 정보를 추가해 주십시오. '
  },
  'developer_be_auth_to_cancel_pp': {
    cn: '该应用已授权，取消授权请在授权列表页面操作',
    en: 'The application has been authorized. To cancel authorization, please operate in the authorization list page',
    kr: '이 응용프로그램은 승인되었습니다. 승인을 취소하려면 승인 리스트 페이지에서 진행해 주십시오. '
  },
  'developer_authorizing_application_by': {
    cn: '您正在为{0}应用开通授权',
    en: 'You are authorizing the {0} application',
    kr: '귀하는 {0}응용프로그램에 대한 승인을 활성화하고 있습니다. '
  },
  'developer_select_auth_text': {
    cn: '请选择授权的接口，默认显示该应用已申请的全部接口，若未显示，则该应用没有该申请接口，若接口置灰不可点则代表您没有这个接口权限，无法进行授权',
    en: 'Please select the authorized interface, and all the interfaces applied by the application will be displayed by default. If it is not displayed, the application does not have the application interface. If the interface is set as grey, it means that you do not have the interface authority and cannot authorize',
    kr: '승인된 인터페이스를 선택하면 기본적으로 이 응용프로그램에 신청된 모든 인터페이스가 표시됩니다. 표시되지 않는 것은 이 응용프로그램에 신청 인터페이스가 없기 때문입니다. 인터페이스가 회색이 되어 클릭할 수 없는 경우 이 인터페이스 권한이 없는 것을 의미하며 승인을 진행할 수 없습니다. '
  },
  'developer_app_not_req_interface': {
    cn: '该应用未申请接口',
    en: 'The application did not request the system interface',
    kr: '이 응용프로그램은 인터페이스를 신청하지 않았습니다. '
  },
  'developer_viewing_auth_t': {
    cn: '您正在查看{app}应用的授权',
    en: 'You are viewing the authorization for the {app}',
    kr: '{app}응용프로그램의 승인을 보기 중입니다. '
  },
  'developer_editing_auth_t': {
    cn: '您正在编辑{app}应用的授权',
    en: 'You are editing the authorization for the {app}',
    kr: '{app}응용프로그램의 승인을 편집 중입니다. '
  },
  'developer_edit_default_auth_permission_text': {
    cn: '默认显示该应用已申请且您有权限进行授权的接口，若未显示，则该应用没有申请该接口或您没有该接口的权限勾选后提交可对该接口进行授权<br>不勾选或取消候选则默认不对该接口进行授权',
    en: 'By default, the interface that the application has applied for and you have permission to authorize is displayed. If it is not displayed, the application does not apply for the interface or you do not have permission to authorize the interface.<br>The interface is not authorized by default if the candidate is not checked or cancelled',
    kr: '기본적으로 이 응용프로그램에서 신청하고 승인할 권한이 있는 인터페이스가 표시됩니다. 표시되지 않을 경우 이 응용프로그램은 이 인터페이스를 신청하지 않았거나 이 인터페이스에 대한 권한이 없는 것입니다. 체크표시를 한 후 제출하면 이 인터페이스에 대한 승인이 진행되며<br> 체크표시를 하지 않거나 선택을 해제한 경우 기본적으로 이 인터페이스에 대한 승인이 이루어지지 않습니다. '
  },
  'developer_concat_user_center': {
    cn: '您可以联系易仓科技商户在用户中心为您授权',
    en: 'You can contact Eccang merchants to authorize you in the User Center',
    kr: '이창(易仓科技)'
  },
  'developer_look_interface_auth': {
    cn: '查看接口授权情况',
    en: 'Look at interface authorization',
    kr: '인터페이스 승인 상황 확인하기'
  },
  'developer_app_name': {
    cn: '应用名称',
    en: 'Application name',
    kr: '응용프로그램명'
  },
  'developer_app_type': {
    cn: '应用类型',
    en: 'Application type',
    kr: '응용프로그램 유형'
  },
  'developer_app_打回': {
    cn: '打回备注',
    en: 'Back to note    ',
    kr: '비고를 되돌려주다'
  },
  'developer_authorization_interface': {
    cn: '授权接口',
    en: 'Authorization interface',
    kr: '승인 인터페이스'
  },
  'developer_authorization_status': {
    cn: '授权状态',
    en: 'Authorization status',
    kr: '승인 상태'
  },
  'developer_authorization_time': {
    cn: '授权时间',
    en: 'Authorization time',
    kr: '승인 시간'
  },
  'developer_operation': {
    cn: '操作',
    en: 'Operation',
    kr: '작업'
  },
  'developer_operator': {
    cn: '操作人',
    en: 'Operator',
    kr: '작업자'
  },
  'developer_operator_ID': {
    cn: '操作ID',
    en: 'Operation ID',
    kr: '작업 ID'
  },
  'developer_operator_IP': {
    cn: '操作IP',
    en: 'Operation IP',
    kr: '작업 IP'
  },
  'developer_operator_opper': {
    cn: '操作对象',
    en: 'Action object',
    kr: '조작 객체'
  },
  'developer_operation_type': {
    cn: '操作类型',
    en: 'Operation type',
    kr: '작업 유형'
  },
  'developer_operation_store': {
    cn: '操作店铺',
    en: 'Operation type',
    kr: '작업 상점'
  },
  'developer_operation_content': {
    cn: '操作内容',
    en: 'Operation content',
    kr: '작업 내용'
  },
  'developer_service_interface': {
    cn: '服务接口',
    en: 'Service interface',
    kr: '서비스 인터페이스'
  },
  'developer_download_successful': {
    cn: '下载成功',
    en: 'Download successful',
    kr: '다운로드 성공'
  },
  'developer_应用类型说明': {
    cn: '应用类型说明',
    en: 'Application Type Description',
    kr: '응용 프로그램 형식 설명'
  },
  'developer_我的应用': {
    cn: '我的应用：已购买ECCANG软件的客户，自研软件开发的(该应用不会显示在应用市场)',
    en: 'My application: Customers who have purchased ECCANG software developed by themselves (this application will not be displayed in the application market)',
    kr: '내 애플리케이션:ECCANG 소프트웨어를 구매한 고객, 자체 개발 소프트웨어 (앱 마켓에는 나타나지 않음)'
  },
  'developer_服务商应用_desc': {
    cn: '服务商应用：为已经购买ECCANG软件的客户提供定制化开发的第三方服务商(已有对接的ECCANG软件客户，定制化开发服务商的应用不会显示在应用市场)',
    en: 'Service provider application: third-party service providers that provide customized development for customers who have purchased ECCANG software (there are already connected ECCANG software customers, and the application of customized development service providers will not be displayed in the application market)',
    kr: '서비스 제공자 애플리케이션:이미 eccang 소프트웨어를 구매한 고객에게 맞춤형 개발을 제공하는 제3자 서비스 제공자 (기존 ECCANG 소프트웨어 도킹 고객에게는 맞춤형 개발 서비스 제공자의 애플리케이션이 애플리케이션 마켓에 표시되지 않음)'
  },
  'developer_基于ECCANG': {
    cn: '基于ECCANG ERP接口二次开发的应用(平台型服务商应用审核通过后会自动上架到应用市场)',
    en: 'ECCANG ERP interface based secondary development of the application (platform service providers will be automatically uploaded to the application market after the application is approved)',
    kr: 'ECCANG ERP 인터페이스 기반의 2차 개발 애플리케이션 (플랫폼 서비스 제공자의 애플리케이션은 승인 후 자동으로 애플리케이션 마켓에 선출시)'
  },
  'developer_自研的其他': {
    cn: '自研的其他网站应用(应用审核通过后会自动上架到应用市场)',
    en: 'Other website applications developed by ourselves (the application will be automatically uploaded to the application market after being approved)',
    kr: '자체로 연구된 기타 사이트 앱 (앱 심의후 자동으로 앱마켓에 설치)'
  },
  'developer_所有应用内容': {
    cn: '所有应用内容需符合国家法律法规，发现含有违法违规和不良信息的，存在数据安全风险隐患的应用，易仓科技将依法依约采取暂停服务、下架等处置措施，保存记录并向有关主管部门报告。',
    en: 'All application content shall comply with national laws and regulations. If it is found to contain illegal and bad information, and there are potential data security risks, Eccang technology will take measures such as suspension of service and removal of the app in accordance with the agreement, and keep records and report to relevant competent authorities.',
    kr: '모든 응용 내용이 국가의 법률과 규정에 부합해야하고, 불법과 불량정보가 포함되고, 데이터 보안 위험이 존재하는 응용이 발견되면, 이창과학기술은 법에 따라 서비스 일시 중지, 선반제거 등 처리 조치를 취하고, 기록을 보존하고 관련 주관부서에 보고한다.'
  },
  'developer_应用类型': {
    cn: '应用类型',
    en: 'App Type',
    kr: '적용 종류'
  },
  'developer_应用属性': {
    cn: '应用属性',
    en: 'App properties',
    kr: '속성 적용'
  },
  'developer_基于eccang': {
    cn: '基于ECCANG ERP二次开发',
    en: 'Secondary development based on ECCANG ERP',
    kr: 'ECCANG ERP 기반의 2차 개발'
  },
  'developer_其他自研网站应用': {
    cn: '其他自研网站应用',
    en: 'Other self-developed website app',
    kr: '기타 자체연구사이트에도 응용되고있다'
  },
  'developer_应用名称(中文)': {
    cn: '应用名称(中文)',
    en: 'Name (Chinese)',
    kr: '적용 이름 (중국어)'
  },
  'developer_应用名称': {
    cn: '应用名称',
    en: 'Name',
    kr: '적용 이름'
  },
  'developer_应用代码': {
    cn: '应用代码',
    en: 'App Code',
    kr: '코드 적용'
  },
  'developer_服务商应用_格式错误': {
    cn: '仅支持30字符内的大写英文或者数字',
    en: 'Only uppercase English or numbers within 30 characters are supported',
    kr: '30자 이내의 대문자 영어 또는 숫자만 지원'
  },
  'developer_限制50个字符': {
    cn: '限制50个字符',
    en: 'Limit to 50 characters',
    kr: '50 글자로 제한합니다'
  },
  'developer_限制500个字符': {
    cn: '限制500个字符',
    en: 'Limit to 500 characters',
    kr: '500 글자로 제한합니다'
  },
  'developer_限制100个字符': {
    cn: '限制100个字符',
    en: 'Limit to 100 characters',
    kr: '100 글자로 제한합니다'
  },
  'developer_应用名称(英文)': {
    cn: '应用名称(英文)',
    en: 'Name(English)',
    kr: '적용 이름 (영어)'
  },
  'developer_应用名称(韩文)': {
    cn: '应用名称(韩文)',
    en: 'Name (Korean)',
    kr: '적용 이름 (한국어)'
  },
  'developer_收费设置': {
    cn: '收费设置',
    en: 'Charging set',
    kr: '유료 설정'
  },
  'developer_收费（暂未开放）': {
    cn: '收费（暂未开放）',
    en: 'Fees(not open yet)',
    kr: '유료화 (아직 개방 안함)'
  },
  'developer_应用简介(中文)': {
    cn: '应用简介(中文)',
    en: 'Introduction(Chinese)',
    kr: '지원 개요(중국어)'
  },
  'developer_应用简介': {
    cn: '应用简介',
    en: 'Introduction',
    kr: '응용 프로그램 소개'
  },
  'developer_应用简介(英文)': {
    cn: '应用简介(英文)',
    en: 'Introduction(English)',
    kr: '응용 개요(영어)'
  },
  'developer_应用简介(韩文)': {
    cn: '应用简介(韩文)',
    en: 'Introduction(Korean)',
    kr: '지원 개요(한국어)'
  },
  'developer_应用分类': {
    cn: '应用分类',
    en: 'Classification',
    kr: '분류 적용'
  },
  'developer_图片应用': {
    cn: '图片应用',
    en: 'Image app',
    kr: '그림 적용'
  },
  'developer_翻译应用': {
    cn: '翻译应用',
    en: 'Translation of app',
    kr: '번역 응용'
  },
  'developer_运营工具应用': {
    cn: '运营工具应用',
    en: 'Operation Tool app',
    kr: '운영 도구 응용'
  },
  'developer_汇率应用': {
    cn: '汇率应用',
    en: 'Exchange rate app',
    kr: '환율적용'
  },
  'developer_选品应用': {
    cn: '选品应用',
    en: 'Choose product app',
    kr: '선택 응용'
  },
  'developer_评论分析应用': {
    cn: '评论分析应用',
    en: 'Review analysis app',
    kr: '비평분석응용'
  },
  'developer_email推广营销应用': {
    cn: 'email推广营销应用',
    en: 'Email promotion marketing app',
    kr: '이메일 마케팅 어플리케이션입니다'
  },
  'developer_其他应用': {
    cn: '其他应用',
    en: 'Other app',
    kr: '기타 응용 프로그램'
  },
  'developer_请选择应用属于哪个分类': {
    cn: '请选择应用属于哪个分类',
    en: 'Select a category for the app',
    kr: '어플리케이션이 어떤 분류에 속하는지 선택하세요'
  },
  'developer_应用链接': {
    cn: '应用链接',
    en: 'App link',
    kr: '링크 적용하기'
  },
  'developer_请您输入您网站链接': {
    cn: '请您输入您的网站链接',
    en: 'Please enter your website link',
    kr: '당신의 사이트 링크를 입력하세요'
  },
  'developer_客户在': {
    cn: '客户在“应用市场”打开您的应用时，将自动打开该应用链接',
    en: 'When a customer opens your app in the App Market, the app link will be automatically opened',
    kr: '고객은 앱 마켓에서 앱을 열면 자동으로 해당 앱 링크를 엽니다'
  },
  'developer_应用配置': {
    cn: '应用配置',
    en: 'App configuration',
    kr: '설정 적용'
  },
  'developer_多个IP地址': {
    cn: '多个IP地址需用；分开',
    en: 'Multiple IP addresses are required;separate',
    kr: '여러 ip 주소가 필요합니다;분리'
  },
  'developer_仅我可见': {
    cn: '仅我可见：仅限创建应用的企业下的员工账号可见（可用于内测）',
    en: 'Only visible to me: Only visible to employee accounts of the enterprise where the application is created (available for internal testing)',
    kr: '저만 볼 수 있습니다:앱을 만드는 회사의 직원 계정만 볼 수 있습니다 (내부 테스트 가능)'
  },
  'developer_全部可见': {
    cn: '全部可见：应用正式上架应用市场，所有客户都可见',
    en: 'All Visible: The app is officially launched in the app marketplace and is visible to all customers',
    kr: '모두 볼 수 있음:응용 프로그램 시장은 공식적으로 오픈, 모든 고객이 볼 수 있음'
  },
  'developer_应用显示': {
    cn: '应用显示',
    en: 'App shows that',
    kr: '디스플레이 적용'
  },
  'developer_仅我可见_': {
    cn: '仅我可见',
    en: 'Only I can see',
    kr: '나만이 보인다'
  },
  'developer_全部可见_': {
    cn: '全部可见',
    en: 'All visible',
    kr: '모두 보기'
  },
  'developer_多个IP地址需用分号隔开': {
    cn: '多个IP地址需用分号隔开，如：192.268.2.1;127.0.0.1',
    en: 'Separate multiple IP addresses with semicolons (;), for example, 192.268.2.1. 127.0.0.1',
    kr: '여러 ip 주소는 세미콜론 (192.268.2.1)으로 구분해야 한다.127.0.0.1'
  },
  'developer_开放给': {
    cn: '开放给所有用户的时候，配置IP为0.0.0.0',
    en: 'To open the service to all users, set the IP address to 0.0.0.0',
    kr: '모든 사용자에게 개방되었을 때, 설정 ip는 0.0.0.0 이었다'
  },
  'developer_域名解析IP': {
    cn: '域名解析IP',
    en: 'DNS IP',
    kr: '도메인 분석 ip'
  },
  'developer_请填写应用的域名IP': {
    cn: '请填写应用的域名IP，每次跳转到应用时，ECCANG都会判断都这个域名的指向IP是否正确，若错误时将不允许跳转',
    en: 'Enter the IP address of the domain name of the application. The ECCANG checks whether the IP address of the domain name is correct. If the IP address is incorrect, the application cannot be redirected',
    kr: '응용 프로그램의 도메인 ip를 입력하십시오. 응용 프로그램으로 이동할 때마다 eccang은 도메인 이름이 가리키는 ip 가 올바른지를 판단합니다. 틀린 경우 도메인 지정을 할 수 없습니다'
  },
  'developer_请正确填写测试账号密码': {
    cn: '请正确填写测试账号密码，应用审核时将使用该账号登录您的应用进行审核，无法登录时应用将审核不通过',
    en: 'Please fill in the test account password correctly. The account will be used to log in to your application for review. If you fail to log in, the application will not pass the review',
    kr: '시험계정비밀번호를 정확하게 기입해주시기 바랍니다. 신청시이 계정으로 신청하여 심사를 받게됩니다. 신청하지 못할 경우 신청이 통과되지 않습니다'
  },
  'developer_图片尺寸要求': {
    cn: '图片尺寸要求：90x90',
    en: 'Image size required: 90x90',
    kr: '그림 크기:90x90'
  },
  'developer_上传logo': {
    cn: '上传logo',
    en: 'Upload a logo',
    kr: '로고 업로드'
  },
  'developer_“功能预览”模块': {
    cn: '“功能预览”模块只允许上传图片或视频 ，单个文件不能超过50MB，最多100个文件',
    en: 'The "Feature Preview" module only allows uploads of images or videos. A single file cannot exceed 50MB and a maximum of 100 files can be uploaded',
    kr: '기능 미리보기 모듈은 그림이나 동영상만 업로드 할 수 있으며, 단일 파일로 50mb 또는 최대 100개까지 업로드 할 수 없습니다'
  },
  'developer_选择文件': {
    cn: '选择文件',
    en: 'Select the file',
    kr: '파일 선택'
  },
  'developer_接口申请': {
    cn: '接口申请',
    en: 'Interface application',
    kr: '인터페이스 신청'
  },
  'developer_申请ECCANG_ERP接口授权': {
    cn: '申请ECCANG ERP接口授权',
    en: 'Apply for ECCANG ERP interface authorization',
    kr: 'ECCANG ERP 인터페이스 인증 신청'
  },
  'developer_请选择需要获取': {
    cn: '请选择需要获取的ECCANG ERP接口授权，',
    en: 'Select the ECCANG ERP interface authorization that you want to obtain.',
    kr: '필요한 ECCANG ERP 인터페이스 인증을 선택하십시오.'
  },
  'developer_用户使用你的应用时': {
    cn: '用户使用你的应用时，系统将自动给予授权提醒，若用户同意授权，您的应用将获得对应授权。',
    en: 'When users use your application, the system will automatically remind them of authorization. If users agree to authorization, your application will get the corresponding authorization.',
    kr: '사용자가 앱을 사용할 때 자동으로 인증 알림이 주어지며, 사용자가 인증에 동의하면 애플리케이션이 인증됩니다.'
  },
  'developer_如果要处理用户数据': {
    cn: '如果要处理用户数据，应用开发者应当在向用户请求获取他们任何个人数据的时候充分告知用户，并取得他们的明确同意。',
    en: 'If user data is to be processed, application developers should fully inform users and obtain their express consent when requesting access to any of their personal data.',
    kr: '사용자 데터처리를 할 경우 응용개발자는 사용자에게 개인데터획득을 요구할 때 사용자에게 충분히 통지하고 그들의 명확한 동의를 얻어야 한다.'
  },
  'developer_账号信息相关授权': {
    cn: '账号信息相关授权',
    en: 'Account information related authorization',
    kr: '계정 정보 인증'
  },
  'developer_注意事项': {
    cn: '注意事项',
    en: 'Matters needing attention',
    kr: '주의 사항'
  },
  'developer_勾选需要申请的权限接口': {
    cn: '勾选需要申请的权限接口，客户在使用您的应用时系统将咨询客户是否同意授权',
    en: 'If you select the permission interface to be applied for, the system will ask the customer whether to grant permission when using your application',
    kr: '응용 프로그램에 필요한 권한 인터페이스를 체크하십시오. 클라이언트가 응용 프로그램을 사용할 때 시스템에서 인증에 대한 동의를 요청합니다'
  },
  'developer_是否必须授权指的是': {
    cn: '“是否必须授权”指的是客户是否必须要授权该接口才能使用您的应用',
    en: '"Must License" refers to whether the customer must license the interface to use your application',
    kr: '"인증 여부"는 고객이 애플리케이션을 사용하기 위해 인터페이스를 인증해야 하는지 여부를 의미합니다'
  },
  'developer_若您选择了开启': {
    cn: '若您选择了开启，则系统咨询客户授权时，该授权将置灰不允许取消，客户若不授权将无法使用您的应用',
    en: 'If you select enable, when the system asks for authorization from the customer, the authorization is unavailable and cannot be cancelled. Otherwise, the customer cannot use your application',
    kr: '켜기를 선택하면 시스템에서 고객에게 인증 요청을 할 때 인증은 취소되지 않으며 고객은 인증 없이는 애플리케이션을 사용할 수 없습니다'
  },
  'developer_若您选择了关闭': {
    cn: '若您选择了关闭，则系统咨询客户授权时，客户不授权也能使用您的应用',
    en: 'If you disable this function, the user can use your application without permission when the system asks for permission from the customer',
    kr: '종료하기로 선택했다면, 시스템에서 고객에게 인증 요청시 고객은 인증 없이 애플리케이션을 사용할 수 있습니다'
  },
  'developer_协议条款确认': {
    cn: '协议条款确认',
    en: 'Confirmation of Terms of agreement',
    kr: '협의조항의 확인'
  },
  'developer_所有应用内容需符合': {
    cn: '所有应用内容需符合国家法律法规，发现含有违法违规和不良信息的，存在数据安全风险隐患的应用，易仓科技将依法依约采取暂停服务、下架等处置措施，保存记录并向有关主管部门报告。',
    en: 'All application content shall comply with national laws and regulations. If it is found to contain illegal and bad information, and there are potential data security risks, Eicang technology will take measures such as suspension of service and removal of the app in accordance with the agreement, and keep records and report to relevant competent authorities.',
    kr: '모든 응용 내용이 국가의 법률과 규정에 부합해야하고, 불법과 불량정보가 포함되고, 데이터 보안 위험이 존재하는 응용이 발견되면, 이창과학기술은 법에 따라 서비스 일시 중지, 선반제거 등 처리 조치를 취하고, 기록을 보존하고 관련 주관부서에 보고한다.'
  },
  'developer_我已阅读并遵守': {
    cn: '我已阅读并遵守',
    en: 'I have read and complied',
    kr: '나는 그것을 읽고 준수하였다'
  },
  'developer_易仓科技开发者服务协议': {
    cn: '易仓科技开发者服务协议',
    en: 'Eccang Technology Developer Service Agreement',
    kr: '이창 과학기술 개발자 서비스 협의'
  },
  'developer_放弃本次编辑': {
    cn: '放弃本次编辑',
    en: 'Abandon this edit',
    kr: '편집 포기'
  },
  'developer_当前内容尚未保存': {
    cn: '当前内容尚未保存，是否确认关闭',
    en: 'The current content is not saved. Do you want to close it',
    kr: '현재 내용이 저장되지 않았습니다. 닫을지 여부입니다'
  },
  'developer_请阅读协议并勾选我已阅读': {
    cn: '请阅读协议并勾选我已阅读',
    en: 'Please read the agreement and tick the box I have read',
    kr: '동의서를 읽고 제가 읽은 것을 체크하세요'
  },
  'developer_请勾选接口': {
    cn: '请勾选接口',
    en: 'Please select the interface.',
    kr: '인터페이스를 체크하십시오'
  },
  'developer_审核通过': {
    cn: '审核通过',
    en: 'Approved',
    kr: '심사를 통과하다'
  },
  'developer_修改待审核': {
    cn: '修改待审核',
    en: 'Modification pending review',
    kr: '수정하여 심의를 기다리다'
  },
  'developer_重置密钥': {
    cn: '重置密钥',
    en: 'Reset key',
    kr: '키 초기화'
  },
  'developer_查看密钥': {
    cn: '查看',
    en: 'View',
    kr: ''
  },
  'developer_编辑成功': {
    cn: '编辑成功！',
    en: 'Edit succeeded',
    kr: '편집이 성공했습니다'
  },
  'developer_新增成功': {
    cn: '新增成功！',
    en: 'New success',
    kr: '추가 성공'
  },
  'developer_接口名称': {
    cn: '接口名称',
    en: 'The name of the interface',
    kr: '추가 성공'
  },
  'developer_是否必须授权': {
    cn: '是否必须授权',
    en: 'Authorization necessary',
    kr: '인증해야 하는지 여부'
  },
  'developer_选择': {
    cn: '选择',
    en: 'choose',
    kr: '선택'
  },
  'developer_测试账号/密码': {
    cn: '测试账号/密码',
    en: 'Test account/password',
    kr: '테스트 계정/비밀번호'
  },
  'developer_应用logo': {
    cn: '应用logo',
    en: 'App logo',
    kr: '로고 적용하기'
  },
  'developer_功能预览': {
    cn: '功能预览',
    en: 'Preview function',
    kr: '기능 미리 보기'
  },
  'developer_功能简介': {
    cn: '功能简介',
    en: 'Function introduction',
    kr: '기능 소개'
  },
  'developer_只允许上传图片或者视屏': {
    cn: '只允许上传图片或者视频',
    en: 'Only images or videos are allowed',
    kr: '그림이나 화면만 업로드할 수 있습니다'
  },
  'developer_上传格式错误': {
    cn: '上传格式错误',
    en: 'Incorrect upload format',
    kr: '업로드 형식 오류'
  },
  'developer_单个文件最大不能超过100M': {
    cn: '单个文件最大不能超过100M',
    en: 'The maximum size of a single file cannot exceed 100 MB',
    kr: '단일 파일은 100m까지 사용할 수 있습니다'
  },
  'developer_单个文件最大不能超过50M': {
    cn: '单个文件最大不能超过50M',
    en: 'The maximum size of a single file cannot exceed 50 MB',
    kr: '단일 파일은 50m까지 사용할 수 있습니다'
  },
  'developer_最多上传100个文件': {
    cn: '最多上传100个文件',
    en: 'A maximum of 100 files can be uploaded',
    kr: '최대 100개 파일 업로드하기'
  },
  'developer_pleaseSelect': {
    cn: '请选择',
    en: 'Please Select',
    kr: '선택하십시오'
  },
  'developer_ip_Limit': {
    cn: 'IP白名单',
    en: 'IP whitelist',
    kr: 'IP 화이트리스트'
  },
  'developer_不能为空': {
    cn: '不能为空',
    en: 'can not be empty',
    kr: '비워둘 수 없습니다.'
  },
  'developer_basic': {
    cn: '基础信息',
    en: 'Basic Information',
    kr: '基础信息'
  },
  'developer_alls': {
    cn: '全选',
    en: 'Select All',
    kr: '전체 선택'
  },
  'developer_total': {
    cn: '共{0}条',
    en: 'Total {0} items',
    kr: '총 {0}'
  },
  'developer_cancel': {
    cn: '取消',
    en: 'Cancel',
    kr: '취소'
  },
  'developer_submit': {
    cn: '提交',
    en: 'Submit',
    kr: '제출'
  },
  'app_永久免费': {
    cn: '永久免费',
    en: 'Permanently free',
    kr: '영구적으로 무료입니다'
  },
  'app_限时免费': {
    cn: '限时免费',
    en: 'Free for a limited time',
    kr: '제한된 시간 동안 무료'
  },
  'authority_当前内容尚未保存，是否确认关闭': {
    cn: '当前内容尚未保存，是否确认关闭？',
    en: 'The current content has not been saved, are you sure to close?',
    kr: '현재 콘텐츠가 저장되지 않았습니다. 종료하시겠습니까?'
  },
  'common_conj_account': {
    cn: '账号',
    en: 'Account',
    kr: '계좌 번호'
  },
  'authority_account_password': {
    cn: '密码',
    en: 'Password',
    kr: '비밀번호'
  },
  'down_search_export_content_1': {
    cn: '准备工作会在后台进行，您可以先进行其他操作；',
    en: 'Preparations are performed in the background. You can perform other operations first.',
    kr: '준비작업은 배경에서 진행되며 당신은 먼저 기타 작업을 할수 있다.'
  },
  'down_search_export_content_2': {
    cn: '文件下载成功后会提醒您下载',
    en: 'You will be reminded to download the file when it is successfully downloaded',
    kr: '파일을 성공적으로 다운로드했을 때, 다운로드하라는 메시지가 표시됩니다'
  },
  'down_search_export_content_3': {
    cn: '您也可以稍后到',
    en: 'You can also come later',
    kr: '잠시 후에 오셔도 됩니다'
  },
  'down_search_export_title': {
    cn: '导出文件准备中',
    en: 'Export file in preparation',
    kr: '내보내기 파일 준비 중'
  },
  'down_search_export_look': {
    cn: '查看',
    en: 'To view',
    kr: '보기'
  },
  'authority_enterprise_edit': {
    cn: '编辑',
    en: 'Edit',
    kr: '편집'
  },
  'authority_account_check': {
    cn: '请检查您的查询条件是否正确',
    en: 'Please check if your query conditions are correct',
    kr: '쿼리 조건이 올바른지 확인하십시오'
  },
  'common_btn_如果您是开发者': {
    cn: '如果您是开发者可以点击“新增”创建应用',
    en: 'If you are a developer, you can click "Add" to create an application',
    kr: '개발자라면 추가를 클릭하여 앱을 만들 수 있습니다'
  },
  'common_menu_ulog': { cn: '操作日志', en: 'Operation log', kr: '작업 로그' },
  'authority_app_querys': {
    cn: '输入应用名称查询',
    en: 'Input Application Name Query',
    kr: '애플리케이션 이름 쿼리 입력'
  },
  'down_file_create_time': {
    cn: '创建时间',
    en: 'Creation time',
    kr: '생성 시간'
  },
  'measure_total': {
    cn: '共{0}条',
    en: 'Total {0} items',
    kr: '총 {0}'
  },
  'common_download': {
    cn: '下载',
    en: 'Download',
    kr: '다운로드'
  },
  'developer_请选择合适的SDK': {
    cn: '请选择合适的SDK版本进行下载',
    en: 'Please select the appropriate SDK version to download',
    kr: '다운로드할 적절한 SDK 버전을 선택하세요.'
  },
  'orderDetail_to_audit': {
    cn: '待审核',
    en: 'To audit',
    kr: '심사 대기'
  },
  'orderDetail_not_approved': {
    cn: '审核不通过',
    en: 'Not approved',
    kr: '심사 미 통과'
  },
  'developer_当前资料正在审核中，不支持重复发起认证': {
    cn: '当前资料正在审核中，不支持重复发起认证',
    en: 'The current information is under review. Duplicate authentication is not supported',
    kr: '현재 자료는 검토 중이므로 중복 인증은 지원되지 않습니다'
  },
  'developer_启用_desc': {
    cn: '确定启用吗',
    en: "Are you sure it's on",
    kr: '활성화되시겠습니까'
  },
  'authority_platformModal_startUsing': {
    cn: '启用',
    en: 'Start using',
    kr: '활성화'
  },
  'authority_rold_added': {
    cn: '新增',
    en: 'Add',
    kr: '새로 추가'
  },
  'orderManage_successful': {
    cn: '操作成功',
    en: 'Operation successful',
    kr: '작업 성공'
  }
}
